module.exports = __webpack_public_path__ + "img/6.879c625d.jpg";